const generate = (el,name,data={}) => {
  const event = new CustomEvent(name, { 'detail': data});
  el.dispatchEvent(event);
};

export default generate;